import { RewardCardTemplate, RewardCardTemplateProps } from "./template";

export type RewardCardProps = RewardCardTemplateProps;

export const RewardCard = (props: RewardCardProps): JSX.Element => {
  return <RewardCardTemplate {...props} />;
};
